import React from 'react';
import Loader from 'components/Loader/Loader';
import SelectableProjectCard from 'components/Shared/Selectors/ProjectSelector/SelectableProjectCard/SelectableProjectCard';

import styles from './ProjectSelector.module.scss';

const ProjectSelector = ({
  loadingProjects = false,
  onSelectProject,
  projects = [],
  selectedProjects = [],
}) => {
  return (
    <div>
      {projects.map((project) => (
        <SelectableProjectCard
          className={styles.card}
          key={project.id}
          onClick={() => onSelectProject(project.id, project.links.main)}
          project={project}
          selected={selectedProjects.includes(project.id)}
        />
      ))}
      <Loader className={styles.loader} loading={loadingProjects} />
      {!loadingProjects && projects.length === 0 && (
        <div className={styles.noProjects}>Your Twine portfolio is empty.</div>
      )}
    </div>
  );
};

export default ProjectSelector;
